import React, { Component } from 'react';
import Dialog from 'components/ContextDialog';
import { getLiteral } from 'utils/getLiteral';
import Button from 'components/Button';
import * as styles from './DeleteLineDialog_styles.js';

class DeleteDialog extends Component {
    state = {};

    render() {
        const { open, actionOnClose, actionOnAccept, title, children } = this.props;

        const actions = [
            <Button text={getLiteral('action_cancel')} type="primary" onClick={actionOnClose} />,
            <Button text={getLiteral('action_delete')} onClick={actionOnAccept} />,
        ];
        // the styles are in javascript because we need to override the inline style
        return (
            <Dialog
                title={title}
                open={open}
                onRequestClose={actionOnClose}
                actions={actions}
                titleStyle={styles.title}
                actionsContainerStyle={styles.container}
            >
                {children}
            </Dialog>
        );
    }
}

export default DeleteDialog;
